import React, { useState, useEffect, isValidElement } from 'react';
import { Card, CardHeader, CardBody, CardText, Collapse, UncontrolledTooltip } from 'reactstrap';
import './Draggable.css';
import { CopyButton } from '..';
import CardIconActions from '../CardIconAction/CardIconActions';
import CardTitleRow from '../CardIconAction/CardTitleRow';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Draggable = ({
    id,
    onCollapse,
    collapsed,
    title,
    badge,
    tags,
    cardbody,
    actions,
    cardActions,
    headerActions,
    headerDetails,
    draggable,
    link,
    toolTip,
    rightContent,
    keepFieldsMounted = false,
}) => {
    const { t } = useTranslation();
    const [collapse, setCollapse] = useState(collapsed);

    useEffect(() => {
        setCollapse(collapsed);
    }, [collapsed]);

    const toggle = (id) => {
        onCollapse(id);
        setCollapse(!collapse);
    };

    const reorderHint = t('common.drag_to_reorder');
    const resolvedCardActions = cardActions || actions;
    const hasMeta = !!(tags || badge);
    const hasBadges = !!rightContent;
    // Actions (+ tags/badge meta) stay absolute top-right. Resume badges live on the
    // row under the title so they can use the full width and not wrap early.
    const hasToolbar = !!(resolvedCardActions || hasMeta);
    const show_below_title = !!(headerDetails || hasBadges);

    const badges_node = rightContent ? (
        <div
            className="Draggable-header-badges"
            onClick={(event) => event.stopPropagation()}
        >
            {rightContent}
        </div>
    ) : null;

    return (
        <Card className='Draggable CardShell'>
            <CardHeader
                tag={link && Link}
                to={link && link}
                id={`draggable-header-${id}`}
                className={`position-relative btn text-left border-0 cardBtnHeader ${hasToolbar ? 'cardBtnHeader--hasToolbar' : ''} ${hasMeta ? 'cardBtnHeader--hasMeta' : ''} ${hasBadges ? 'cardBtnHeader--hasBadges' : ''} ${(onCollapse !== undefined || link !== undefined) && "hoverable"}`}
                onClick={(event) => {
                    if (event.defaultPrevented)
                        return;
                    if (event.target?.closest?.('.Draggable-header-badges')) {
                        event.preventDefault();
                        return;
                    }
                    if (event.target?.closest?.('.CardIconActions')) {
                        // Nested action Links (e.g. delete) must keep their navigation;
                        // button-only actions already call preventDefault themselves.
                        const nested_anchor = event.target.closest('.CardIconActions a');
                        if (!nested_anchor)
                            event.preventDefault();
                        return;
                    }
                    if (onCollapse !== undefined)
                        toggle(id);
                }}
            >
                {hasToolbar && (
                    <div className="Draggable-header-toolbar">
                        {resolvedCardActions ? (
                            <CardIconActions inline className="Draggable-cardActions">
                                {resolvedCardActions}
                            </CardIconActions>
                        ) : (
                            badge && <div className="Draggable-header-actionsSpacer" aria-hidden="true" />
                        )}
                        {(tags || badge) && (
                            <div className="Draggable-header-meta">
                                {tags && (
                                    <div className="Draggable-header-tags d-flex flex-wrap justify-content-end align-items-center">
                                        { tags.map((tag, i) => (
                                            <CopyButton key={tag._id ?? tag.id ?? `${tag.name}-${i}`} size="xs" badge color="dark" textToCopy= { tag.name } />
                                        ))}
                                    </div>
                                )}
                                {badge && (
                                    isValidElement(badge)
                                        ? badge
                                        : <CopyButton size="sm" badge color="info" textToCopy={badge} />
                                )}
                            </div>
                        )}
                    </div>
                )}
                <div className="Draggable-header-main">
                    <h4 className="m-0 Draggable-header-title">
                        {draggable !== false ? (
                            <CardTitleRow draggable dragTitle={reorderHint}>
                                {title}
                            </CardTitleRow>
                        ) : (
                            title && title
                        )}
                    </h4>
                    {show_below_title && (
                        <div className="Draggable-header-belowTitle">
                            {headerDetails && (
                                <div className="Draggable-header-details">
                                    {headerDetails}
                                </div>
                            )}
                            {badges_node}
                        </div>
                    )}
                </div>
                {headerActions && (
                    <div className="Draggable-header-actions">
                        {headerActions}
                    </div>
                )}
            </CardHeader>
            {toolTip &&
                <UncontrolledTooltip target={`draggable-header-${id}`}>{toolTip}</UncontrolledTooltip>
            }
            {(onCollapse !== undefined || !cardbody) ?
                <Collapse isOpen={collapse}>
                    <CardBody>
                        <CardText tag="div">
                            {cardbody && (keepFieldsMounted || collapse) &&
                                cardbody}
                        </CardText>
                    </CardBody>
                </Collapse>
                :
                <CardBody>
                    <CardText tag="div">
                        {cardbody &&
                            cardbody}
                    </CardText>
                </CardBody>
            }
        </Card>
    );
};

export default Draggable;
